/**
 * Accent- and case-insensitive matching.
 *
 * Non-negotiable in Spanish: nobody typing fast at a counter is going to reach for the accent
 * on "limón", and a search that fails to find it looks like the product does not exist.
 */
export function normalizar(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * A name as two people would both write it: case and spacing apart. What a new supplier or client
 * is held against, so the same one is not added twice under another capital.
 */
export const comoNombre = (s: string): string => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('es');

/** Every term must appear somewhere, in any order: "arroz 80" finds "Arroz 80/20". */
export function coincide(texto: string, consulta: string): boolean {
  const t = normalizar(texto);
  const terminos = normalizar(consulta).split(/\s+/).filter(Boolean);
  return terminos.every((term) => t.includes(term));
}

/** Ranks an exact prefix above a mid-string hit, so "arroz" puts "Arroz" before "Harina de arroz". */
export function puntaje(texto: string, consulta: string): number {
  const t = normalizar(texto);
  const q = normalizar(consulta);
  if (!q) return 0;
  if (t === q) return 0;
  if (t.startsWith(q)) return 1;
  const i = t.indexOf(q);
  return i >= 0 ? 2 + i / 1000 : 100;
}

/**
 * At most `max` UTF-16 units, as the schemas count them, without cutting a character in two: an
 * emoji is two units, and half of one is text the server cannot store (`textoQueNoSeGuarda`).
 */
export function cortarTexto(texto: string, max: number): string {
  let corto = '';
  for (const caracter of texto) {
    if (corto.length + caracter.length > max) break;
    corto += caracter;
  }
  return corto;
}
